// ConcurrentChangeDto (409 E_FO_MODIFIED_BY_ANOTHER_USER) -> conflict shape consumed by
// GeneralBlock (RN77/E2, GATE 1: D1 (b)+(b2)). `changedFields` may come back empty when Sun cannot
// determine which fields moved — the rejection is still valid, the warning just degrades to a
// generic "the order has changed" instead of naming fields (S93).
export const concurrentChangeConflict = (data) => {
  const source = data || {}
  const changedFields = Array.isArray(source.changedFields) ? source.changedFields : []
  return {
    changedFields,
    degraded: changedFields.length === 0,
    lastModified: source.lastModified || '',
    lastModifiedBy: source.lastModifiedBy || {}
  }
}

export const isConcurrentChangeError = (error) =>
  error?.status === 409 && error?.data?.code === 'E_FO_MODIFIED_BY_ANOTHER_USER'
